import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import UserAccessLogsPage from './UserAccessLogsPage.vue';

const meta = {
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/user-access-logs'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'user_access_logs',
          meta,
          component: UserAccessLogsPage,
        },
      ],
    },
  ],
};
